<template>
    <modal-template>
        <div slot="header">
            {{ trans('users.headline.edit_assignment') }}
        </div>

        <div slot="body">
            <div class="form">
                <div class="form-row">
                    <div class="form-row__col">
                        <label class="label" for="client">{{
                            trans('courses.label.debit_from')
                        }}</label>
                        <select
                            class="form-select"
                            name="debit_client_id"
                            v-model="debitClientId"
                            @change="recalculateLicenseAmount()"
                        >
                            <option value="">{{
                                trans('courses.label.select')
                            }}</option>
                            <option
                                :value="client.id"
                                v-for="client in clients"
                                :key="client.id"
                                :selected="
                                    assignment.debit_client_id == client.id
                                "
                                :disabled="
                                    client.license_plan ==
                                        'license_plan_alpha' &&
                                        client.license_amount == 0
                                "
                            >
                                {{ client.prefixed_name }}
                                {{
                                    client.license_plan == 'license_plan_alpha'
                                        ? '(' +
                                          trans('licenses.label.amount') +
                                          ': ' +
                                          client.license_amount +
                                          ')'
                                        : ''
                                }}
                            </option>
                        </select>
                    </div>

                    <div class="form-row__col">
                        <form-date
                            name="start_date"
                            v-model="selectedStartDate"
                            :min-date="minDate"
                            :disabled="startDateIsToday"
                        >
                            {{ trans('users.label.start_date') }}
                        </form-date>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-row__col">
                        <form-date
                            name="next_assignment_at"
                            v-model="selectedNextAssignmentAt"
                            :min-date="minDateNextAssignmentAt"
                        >
                            {{ trans('users.label.next_assignment_at') }}
                        </form-date>
                    </div>

                    <div class="form-row__col">
                        <form-date
                            name="end_date"
                            v-model="selectedEndDate"
                            :min-date="minDate"
                        >
                            {{ trans('courses.label.end_date') }}
                        </form-date>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="modal-buttons">
            <div>
                <button
                    type="button"
                    @click="$emit('close')"
                    class="btn btn--tertiary"
                >
                    {{ trans('buttons.cancel') }}
                </button>
            </div>

            <div>
                <button
                    type="button"
                    :disabled="!selectedStartDate"
                    @click="submit"
                    class="btn btn--primary"
                >
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </modal-template>
</template>

<script>
export default {
    props: ['assignment', 'clientsProp'],

    data() {
        return {
            originalClients: [],
            clients: this.clientsProp,
            selected: null,
            debitClientId: this.assignment.debit_client_id,
            selectedStartDate: this.assignment.start_date_original,
            selectedNextAssignmentAt: this.assignment
                .next_assignment_at_original,
            selectedEndDate: this.assignment.end_date_original,
            datepicker: {
                startDate: new Date(),
                preSelectedDate: new Date(),
            },
            minDate: new Date(Date.now()),
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content'),
        };
    },

    computed: {
        /**
         * If courses has been assigned already then start date can not be changed
         */
        startDateIsToday() {
            var today = new Date();
            var startDate = new Date(this.assignment.start_date_original);

            return startDate.getTime() <= today.getTime();
        },

        minDateNextAssignmentAt() {
            if (this.startDateIsToday) {
                return new Date(Date.now());
            }

            return new Date(this.assignment.start_date_original);
        },
    },

    methods: {
        submit() {
            axios
                .post(
                    this.route('tenantapi.users.assignments.edit', {
                        user: this.assignment.user_id,
                        assignment: this.assignment.id,
                    }),
                    {
                        _token: this.csrf,
                        start_date: this.selectedStartDate,
                        next_assignment_at: this.selectedNextAssignmentAt,
                        end_date: this.selectedEndDate,
                        debit_client_id: this.debitClientId,
                    }
                )
                .then(response => {
                    this.flash(response);

                    // Close modal
                    this.$emit('close');
                })
                .catch(error => {
                    // Get validation error messages
                    console.log(error);
                });
        },

        getOriginalClientData() {
            // Deep copy clients object without any reference
            this.clients = JSON.parse(JSON.stringify(this.originalClients));
        },

        /**
         * Recalculate license amount after selecting debit client.
         */
        recalculateLicenseAmount() {
            this.getOriginalClientData();

            var client = this.clients.find(client => {
                return client.id == this.debitClientId;
            });

            if (client) {
                client.license_amount -= 1;
            }
        },
    },

    mounted() {
        this.originalClients = JSON.parse(JSON.stringify(this.clients));
    },
};
</script>
